import { Component, OnInit } from '@angular/core';
import { ClientService } from '../service/client.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MustMatch } from './must-match.validator';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reinit-password',
  templateUrl: './reinit-password.component.html',
  styleUrls: ['./reinit-password.component.scss']
})
export class ReinitPasswordComponent implements OnInit {
  
  code: string;
  errorDevice : boolean;
  errorMessage: string = "";

  public passwordForm: FormGroup;
  public submitted = false;
  protected displayError = false;

  public password: string;
  public confirmPassword: string;

  public afterSuccess: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private clientService: ClientService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      console.log(params);
      this.code = params.code;
      this.errorDevice = params.errorDevice;
    });

    if (this.code === undefined || this.errorDevice) {
      this.errorMessage = "Code de réinitialisation incorrect. Veuillez vérifier l'url qui vous a été envoyée par mail. "
      if (this.errorDevice){
        this.errorMessage += "Si vous pensez que votre compte a été piraté, nous vous recommandons de modifier votre mot de passe."
      }
    } else {
      this.passwordForm = this.formBuilder.group({
        newPassword: this.formBuilder.control(this.password, [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z])(?=.*[\-_!@#\$%\^&\*])(?=.{1,})/)]),
        confirmPassword: this.formBuilder.control(this.confirmPassword, [Validators.required])
      }, {
          validator: MustMatch('newPassword', 'confirmPassword')
      });
      this.clientService.isExistingCode(this.code).subscribe(data => {
      }, err => {
        this.errorMessage = "Code de réinitialisation incorrect. Veuillez vérifier l'url qui vous a été envoyée par mail."
      }); 
    }
  }

  isError() {
    return this.errorMessage !== "";
  }

  /**
   * convenience getter for easy access to form fields
   */
  get field() {
    return this.passwordForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    
    // stop here if form is invalid
    if (this.passwordForm.invalid) {
      return;
    }

    this.clientService.postReinitPassword(this.code, this.passwordForm.value.newPassword).subscribe(data => {
      this.toastr.success("Votre mot de passe a été modifié avec succès !");
      this.afterSuccess = true;
    }, err => {
      this.toastr.error("Vous ne pouvez pas réutiliser un ancien mot de passe. Merci de réessayer.");
    })
  }

}
